import React, { createContext, useContext, useState } from 'react';
import { Title, Image } from './components';
import Link from 'next/link';

export const COLLAPSED_MODE_MAX_ITEMS = 4;

interface ITreeCardContextProps {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const TreeCardContext = createContext<ITreeCardContextProps>({
  isExpanded: false,
  setIsExpanded: () => ({}),
});

interface ITreeCardProps {
  children: React.ReactNode;
  label: string;
  url: string;
  icon?: string;
  listCount: number;
}

export const useTreeCard = () =>
  useContext<ITreeCardContextProps>(TreeCardContext);

const TreeCard: React.FC<ITreeCardProps> = ({
  label,
  url,
  icon,
  listCount,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isListExpandable = listCount > COLLAPSED_MODE_MAX_ITEMS;
  const commonClassNames =
    'tw-flex tw-min-w-[300px] tw-max-w-[373.33px] tw-flex-1 tw-flex-col tw-gap-4 tw-rounded-2xl tw-bg-white tw-p-4';

  return (
    <TreeCardContext.Provider value={{ isExpanded, setIsExpanded }}>
      {listCount > 0 ? (
        <div
          className={`${commonClassNames} ${
            !isListExpandable ? '[&>button]:tw-hidden' : ''
          }  ${!isListExpandable ? 'last:[&_li]:tw-border-b-0' : ''}`}
        >
          {children}
        </div>
      ) : (
        <Link
          href={url}
          title={label}
          className={`${commonClassNames} tw-h-full tw-pb-9 [&_a]:hover:tw-decoration-black-1000`}
        >
          {icon && <Image src={icon} />}
          <Title
            label={label}
            url={url}
            dataTestId={`Tree card title link ${label}`}
          />
        </Link>
      )}
    </TreeCardContext.Provider>
  );
};

export default TreeCard;
